import {
  Link as RouterLink,
  type LinkComponentProps,
} from '@tanstack/react-router';
import { cn } from 'cn';

type P = LinkComponentProps;

export const Link = ({ children, className, style, to, ...rest }: P) => (
  <RouterLink
    className={cn(
      'text-tiga-action-default hover:text-tiga-action-lighter',
      className,
    )}
    style={style}
    to={to}
    {...rest}
  >
    {children}
  </RouterLink>
);
